// frontend/src/api/projectClient.ts
import { ProjectDetail } from "../model/backendTypes";
import { apiFetch } from "./baseClient";


export async function listProjects(
  userId: number
): Promise<ProjectDetail[]> {
  const resp = await apiFetch(
    `/api/projects/list?user_id=${encodeURIComponent(String(userId))}`,
    { method: "GET" }
  );
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `HTTP ${resp.status}`);
  }
  return resp.json() as Promise<ProjectDetail[]>;
}

export async function createNewProject(userId: number): Promise<ProjectDetail> {
  const resp = await apiFetch(
    `/api/projects/new?user_id=${encodeURIComponent(String(userId))}`,
    { method: "POST" }
  );

  if (!resp.ok) {
    let detail = "";

    try {
      const data = await resp.json();
      detail = data?.detail;
    } catch {
      // fallback bleibt leer
    }

    throw new Error(detail || `HTTP ${resp.status}`);
  }

  return resp.json() as Promise<ProjectDetail>;
}

export async function openProject(
  userId: number,
  projectId: number
): Promise<ProjectDetail> {
  const resp = await apiFetch(
    `/api/projects/open?user_id=${encodeURIComponent(String(userId))}&project_id=${encodeURIComponent(String(projectId))}`,
    { method: "POST" }
  );
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `HTTP ${resp.status}`);
  }
  return resp.json() as Promise<ProjectDetail>;
}

export async function duplicateProject(
  userId: number,
  projectId: number
): Promise<ProjectDetail> {
  const resp = await apiFetch(
    `/api/projects/duplicate?user_id=${encodeURIComponent(String(userId))}&project_id=${encodeURIComponent(String(projectId))}`,
    { method: "POST" }
  );
  if (!resp.ok) {
    let detail = "";
    try {
      const data = await resp.json();
      detail = data?.detail;
    } catch {
      // fallback bleibt leer
    }
    throw new Error(detail || `HTTP ${resp.status}`);
  }
  return resp.json() as Promise<ProjectDetail>;
}

export async function deleteProject(
  userId: number,
  projectId: number
): Promise<ProjectDetail> {
  const resp = await apiFetch(
    `/api/projects/delete?user_id=${encodeURIComponent(String(userId))}&project_id=${encodeURIComponent(String(projectId))}`,
    { method: "POST" }
  );
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `HTTP ${resp.status}`);
  }
  return resp.json() as Promise<ProjectDetail>;
}

export async function renameProject(
  userId: number,
  projectId: number,
  newName: string
): Promise<ProjectDetail> {
  const resp = await apiFetch("/api/projects/rename", {
    method: "POST",
    body: {
      user_id: userId,
      project_id: projectId,
      new_name: newName,
    } as any,
  });

  if (!resp.ok) {
    const text = await resp.text();
    console.error("renameProject failed:", resp.status, text);
    throw new Error(`renameProject failed: ${resp.status} ${text}`);
  }

  return (await resp.json()) as ProjectDetail;
}

export async function updateSolverMode(
  userId: number,
  projectId: number,
  solverMode: string
): Promise<ProjectDetail> {
  const resp = await apiFetch("/api/projects/solver_mode", {
    method: "POST",
    body: {
      user_id: userId,
      project_id: projectId,
      solver_mode: solverMode,
    } as any,
  });

  if (!resp.ok) {
    const text = await resp.text();
    console.error("updateSolverMode failed:", resp.status, text);
    throw new Error(`updateSolverMode failed: ${resp.status} ${text}`);
  }

  return (await resp.json()) as ProjectDetail;
}